{
  "name": "@thednp/position-observer",
  "version": "1.1.0",
  "author": "thednp",
  "license": "MIT",
  "description": "🏯 PositionObserver is a JavaScript tool that provides a way to asynchronously observe changes in the position of a target element within its viewport.",
  "homepage": "https://thednp.github.io/position-observer/",
  "source": "./src/index.ts",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "pre-test": "pnpm clean-coverage",
    "dev": "vite --open ./demo/index.html --port 8577",
    "serve": "vite --open ./docs/index.html --port 8577",
    "test": "pnpm pre-test && vitest --config vitest.config.ts",
    "test-ui": "pnpm pre-test && vitest --config vitest.config-ui.ts --browser=chrome",
    "clean-coverage": "rm -rf coverage .nyc_output",
    "badges": "npx -p dependency-version-badge update-badge typescript vitest vite",
    "build": "tsdown",
    "build_": "vite build",
    "build:all": "pnpm build && pnpm build:docs",
    "build:docs": "vite build demo --config demo/vite.config.ts",
    "lint": "deno lint src && pnpm check:ts",
    "format": "deno fmt src",
    "check:ts": "tsc --noEmit",
    "prepublishOnly": "pnpm update --latest && pnpm lint && pnpm format && pnpm build:all && pnpm badges"
  },
  "bugs": {
    "url": "https://github.com/thednp/position-observer/issues"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/thednp/position-observer.git"
  },
  "keywords": [
    "position-observer",
    "observer",
    "intersection",
    "resize",
    "position",
    "typescript"
  ],
  "dependencies": {
    "@thednp/shorty": "^2.0.11"
  },
  "devDependencies": {
    "@types/node": "^24.0.0",
    "@vitest/browser": "^3.2.3",
    "@vitest/coverage-istanbul": "^3.2.3",
    "@vitest/ui": "^3.2.3",
    "playwright": "^1.53.0",
    "tsdown": "^0.12.7",
    "typescript": "5.8.3",
    "vite": "^6.3.5",
    "vitest": "^3.2.3"
  },
  "packageManager": "pnpm@8.6.12",
  "engines": {
    "node": ">=16",
    "pnpm": ">=8.6.0"
  }
}
